export default [["en-us", {
  "@adc/ui-components": {
    "add": "Add",
    "addItems": "Add {itemsText}",
    "additionalResults": "{count} additional searchable results...",
    "all": "All",
    "allItems": "All {items}",
    "am": "AM",
    "apply": "Apply",
    "aurora": "Aurora",
    "beginText": "Starting at",
    "cancel": "Cancel",
    "canyon": "Canyon",
    "changeColorSection": "Change color section",
    "changeColorSelector": "Use arrows to change the color",
    "cherryBlossom": "Cherry blossom",
    "clearSearch": "Clear search",
    "close": "Close",
    "collapse": "Collapse",
    "colonSeparatedText": "{first}: {second}",
    "color": "Color",
    "colors": "Colors",
    "components": {
      "adc-banner": {
        "infoMessage": "Info: {message}",
        "issueMessage": "Issue: {message}"
      },
      "date-range-picker": {
        "selectDate": "Select a Date",
        "selectDateRange": "Select Date Range"
      },
      "multi-schedule-view": {
        "allDay": "All Day"
      },
      "spinner-svg": {
        "loading": "Loading..."
      },
      "week-view": {
        "dayAriaLabel": "To select {dayName}, press space or enter."
      }
    },
    "confirm": "Confirm",
    "confirmPasswordLabel": "Confirm Password",
    "coolWhite": "Cool White",
    "currentPasswordLabel": "Current Password",
    "dayWhite": "Day White",
    "daybreak": "Daybreak",
    "delete": "Delete",
    "deleteMessage": "Are you sure you want to delete?",
    "dimmerSlider": "Dimmer slider",
    "dropdownTitle": "Actions",
    "dusk": "Dusk",
    "edit": "Edit",
    "emptyPasswordStrengthText": "No Password",
    "endText": "Ending at",
    "error": "Error",
    "expand": "Expand",
    "expectedFormat": "Expected format: {format}",
    "fairPasswordStrengthText": "Fair",
    "fiji": "Fiji",
    "generate": "Generate",
    "goodPasswordStrengthText": "Good",
    "hidePassword": "Hide Password",
    "hueSlider": "Hue slider",
    "info": "Info",
    "issue": "Issue",
    "lettersRequired": "{count, plural,\n    =0 {No letter requirement.}\n    =1 {Must contain at least # letter.}\n    other {Must contain at least # letters.}\n}",
    "lightOff": "Turn the light off",
    "lightOn": "Turn the light on",
    "loading": "Loading...",
    "luminosity": "Luminosity",
    "navModalSubMenu": "{parentMenuName} submenu",
    "nebula": "Nebula",
    "newPasswordLabel": "New Password",
    "nextDayText": "(next day)",
    "noItems": "No {itemsText} have been selected. Click \"Add {itemsText}\" to get started.",
    "noResults": "No results",
    "noSearchResults": "No search results",
    "none": "None",
    "numbersRequired": "{count, plural,\n    =0 {No number requirement.}\n    =1 {Must contain at least # number.}\n    other {Must contain at least # numbers.}\n}",
    "off": "Off",
    "ok": "Ok",
    "on": "On",
    "openList": "Open list",
    "pacific": "Pacific",
    "passwordConfirmationError": "Password doesn't match.",
    "passwordStrengthLabel": "Password Strength",
    "passwordTipsLabel": "Tips to make a strong password",
    "picker": "Picker",
    "pleaseSelect": "Please Select",
    "pm": "PM",
    "presets": "Presets",
    "promiseFailed": "The following error occurred: {error}",
    "removeAll": "Remove All",
    "rename": "Rename",
    "requiredLength": "{count, plural,\n    =0 {No character requirement.}\n    =1 {Must contain at least # character.}\n    other {Must contain at least # characters.}\n}",
    "requirementLabel": "Minimum Requirements",
    "revealPassword": "Reveal Password",
    "scannerBar": "Scan a Barcode",
    "scannerBoth": "Scan a Barcode or QR code",
    "scannerQR": "Scan a QR code",
    "search": "Search",
    "selected": "Selected",
    "selectedItems": "Selected {itemsText}",
    "sessionEnded": "Session ended",
    "softWhite": "Soft White",
    "some": "Some",
    "specifyDateAndTime": "Specify the Date and Time",
    "startTime": "Start Time",
    "strongPasswordStrengthText": "Strong",
    "success": "Success",
    "suggestedSearches": "Suggested Searches",
    "symbolsRequired": "{count, plural,\n    =0 {No symbol requirement.}\n    =1 {Must contain at least # symbol.}\n    other {Must contain at least # symbols.}\n}",
    "temperature": "Temperature",
    "timeFormat": "Please adhere to this time format \"{format}\"",
    "timeInvalidMax": "Value must be {time} or earlier",
    "timeInvalidMin": "Value must be {time} or later",
    "triggerDropdown": "Press ENTER, SPACE, UP ARROW or DOWN ARROW to trigger list",
    "triggerSelect": "Press ENTER, SPACE, UP ARROW + ALT or DOWN ARROW + ALT to trigger select",
    "turnOff": "Turn off",
    "turnOn": "Turn on",
    "viewMore": "View more",
    "warmWhite": "Warm White",
    "warning": "Warning",
    "weakPasswordStrengthText": "Weak"
  },
  "generic": {
    "back": "Back",
    "cancel": "Cancel",
    "hide": "Hide",
    "ok": "Ok",
    "show": "Show"
  }
}]];